import React from "react";
import { default as _Select } from "react-select";
export var Select = function Select(props) {
  var style = {};
  return React.createElement(_Select, Object.assign({
    classNamePrefix: "vseth-react-select",
    theme: function theme(_theme) {
      return Object.assign(Object.assign({}, _theme), {
        colors: Object.assign({}, _theme.colors)
      });
    }
  }, props));
};